import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combina clases condicionales de Tailwind resolviendo conflictos
 * (la última clase especificada gana).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
